<script>
import { h, cloneVNode } from 'vue';
import MdListItemButton from './mdListItemButton.vue';
import MdListItemLink from './mdListItemLink.vue';
import MdListItemRouter from './mdListItemRouter.vue';
import MdListItemExpand from './mdListItemExpand.vue';
import MdListItemDefault from './mdListItemDefault.vue';

export default {
  props: {
    href: String,
    disabled: Boolean,
  },
  methods: {
    toggleExpandList() {
      if (this.$refs['listItem'] && this.$refs['listItem'].toggleExpandList) {
        this.$refs['listItem'].toggleExpandList();
      }
    },
  },
  render() {
    let children = this.$slots.default();
    let slots = {};
    const getItemComponent = () => {
      const interactionEvents = ['onContextMenu', 'onDdblClick', 'onDragend', 'onMousedown', 'onTouchstart', 'onClick'];

      if (children.length === 1 && typeof children[0].type === 'symbol' && children[0].children instanceof Array) {
        children = children[0].children;
      }

      let childrenCount = (children && children.length) || 0;

      if (this.href) {
        return MdListItemLink;
      }

      while (childrenCount--) {
        const options = children[childrenCount].type;
        if (options) {
          if (options === 'md-list-expand' || options.name === 'MdListExpand' || options.name === 'md-list-expand') {
            const expandComponent = children[childrenCount];
            slots = {
              expand: () => expandComponent,
            };
            children.splice(childrenCount, 1);
            return MdListItemExpand;
          } else if (options === 'router-link' || options.name === 'RouterLink') {
            slots = {
              default: () => cloneVNode(children[childrenCount], { class: 'md-list-item-container md-button' }),
            };
            return MdListItemRouter;
          }
        }
      }

      if (this.$attrs) {
        let counter = interactionEvents.length;

        while (counter--) {
          if (this.$attrs[interactionEvents[counter]]) {
            return MdListItemButton;
          }
        }
      }

      return MdListItemDefault;
    };

    const comp = getItemComponent();
    return h(
      comp,
      { ...this.$attrs, href: this.href, disabled: this.disabled || null, ref: 'listItem' },
      {
        default: () => children,
        ...slots,
      }
    );
  },
};
</script>
